import { useState } from 'react';
import PageHeader from '../components/layout/PageHeader';
import SettingsCRUDTable from '../components/settings/SettingsCRUDTable';
import {
  listWarehouses, listVendors, listManufacturers, listItemTypes,
  warehousesApi, vendorsApi, manufacturersApi, itemTypesApi,
} from '../lib/api';

type Tab = 'warehouses' | 'vendors' | 'manufacturers' | 'item-types';

const TABS: { id: Tab; label: string }[] = [
  { id: 'warehouses',    label: 'Warehouse Locations' },
  { id: 'vendors',       label: 'Vendors' },
  { id: 'manufacturers', label: 'Manufacturers' },
  { id: 'item-types',    label: 'Item Types' },
];

export default function Settings() {
  const [tab, setTab] = useState<Tab>('warehouses');

  return (
    <div className="h-full flex flex-col">
      <PageHeader
        title="Settings"
        breadcrumb={[{ label: 'Dashboard', href: '/dashboard' }, { label: 'Settings' }]}
      />

      {/* Tabs */}
      <div className="border-b border-gray-200 bg-white px-6 flex gap-1">
        {TABS.map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
              tab === t.id
                ? 'border-brand-600 text-brand-700'
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="flex-1 overflow-y-auto p-6">
        {tab === 'warehouses' && (
          <SettingsCRUDTable
            title="Warehouses"
            queryKey="warehouses"
            fetchFn={listWarehouses}
            createFn={warehousesApi.create}
            updateFn={warehousesApi.update}
            deleteFn={warehousesApi.remove}
            hasParent={false}
          />
        )}
        {tab === 'vendors' && (
          <SettingsCRUDTable
            title="Vendors"
            queryKey="vendors"
            fetchFn={listVendors}
            createFn={vendorsApi.create}
            updateFn={vendorsApi.update}
            deleteFn={vendorsApi.remove}
            hasParent={true}
          />
        )}
        {tab === 'manufacturers' && (
          <SettingsCRUDTable
            title="Manufacturers"
            queryKey="manufacturers"
            fetchFn={listManufacturers}
            createFn={manufacturersApi.create}
            updateFn={manufacturersApi.update}
            deleteFn={manufacturersApi.remove}
            hasParent={true}
          />
        )}
        {tab === 'item-types' && (
          <SettingsCRUDTable
            title="Item Types"
            queryKey="item-types"
            fetchFn={listItemTypes}
            createFn={itemTypesApi.create}
            updateFn={itemTypesApi.update}
            deleteFn={itemTypesApi.remove}
            hasParent={true}
          />
        )}
      </div>
    </div>
  );
}
